import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const SavingsSituation = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { before, after, equity, available, downPayment, closingCost, monthsSavings, hasHouse } = props;

  return (
    <Box className={classes.paper}>
      <Typography variant="body1" color="inherit" className={classes.label}>
        {t('components.Quiz.SummaryPage.SavingsSituation.label')}
      </Typography>
      <Box display="flex" mt={2}>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.SavingsSituation.before')}
          </Typography>
        </Box>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={before} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
      </Box>
      {hasHouse && (
        <Box>
          <Box display="flex" mt={0.8}>
            <Box width="70%">
              <Typography color="secondary" variant="body2">
                {t('components.Quiz.SummaryPage.SavingsSituation.equity')}
              </Typography>
            </Box>
            <Box width="30%">
              <Typography color="secondary" variant="body1" className={classes.bold}>
                <NumberFormat value={equity} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
              </Typography>
            </Box>
          </Box>
          <Box display="flex" mt={0.8}>
            <Box width="70%">
              <Typography color="secondary" variant="body2">
                {t('components.Quiz.SummaryPage.SavingsSituation.available')}
              </Typography>
            </Box>
            <Box width="30%">
              <Typography color="secondary" variant="body1" className={classes.bold}>
                <NumberFormat value={available} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      <Box display="flex" mt={0.8}>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.SavingsSituation.downPayment')}
          </Typography>
        </Box>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={downPayment} displayType="text" thousandSeparator decimalScale={0} prefix="-$" />
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.SavingsSituation.closingCosts')}
          </Typography>
        </Box>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={closingCost} displayType="text" thousandSeparator decimalScale={0} prefix="-$" />
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="70%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.SavingsSituation.after')}
          </Typography>
        </Box>
        <Box width="30%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={after} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
      </Box>
      <Box className={classes.divider} />
      <Typography color="secondary" variant="body2">
        {t('components.Quiz.SummaryPage.SavingsSituation.monthsSavings', { months: monthsSavings.toFixed(1) })}
      </Typography>
    </Box>
  );
};

SavingsSituation.propTypes = {
  before: PropTypes.number.isRequired,
  after: PropTypes.number.isRequired,
  available: PropTypes.number.isRequired,
  equity: PropTypes.number.isRequired,
  downPayment: PropTypes.number.isRequired,
  closingCost: PropTypes.number.isRequired,
  monthsSavings: PropTypes.number.isRequired,
  hasHouse: PropTypes.bool.isRequired,
};

export default SavingsSituation;



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/SavingsSituation/SavingsSituation.js